import eq from "./component-library413.mjs";
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}
export {
  assocIndexOf as default
};
